import React from 'react'
import { InstalmentsList } from './list/page'

export const InstalmentsListPage = (): JSX.Element => {
  return <InstalmentsList />
}
